const escapeHtmlText = (text: string) =>
    text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

/**
 * Session replay (PostHog) masks text inside a `ph-mask` element even when its grid cell or row is
 * unmasked: the nearest marker wins. Wrap a person's name in it when it shares a cell with safe
 * text, e.g. an order's creator, who can be an investor.
 *
 * The name is escaped as text first. Interpolated as markup, a name could close the span and open
 * a `ph-unmask` one (the sanitizer keeps both `span` and `class`), and then be recorded.
 */
export const replayMaskedHtml = (text: string | null | undefined) =>
    `<span class="ph-mask">${escapeHtmlText(String(text ?? ''))}</span>`;
